module.exports = __webpack_public_path__ + "static/redime-tus-puntos-4-067ebd04f1886ece78153b8bd3d4df30.png";